import React from "react";
import * as THREE from "three";
import { DirectionalLightConfig } from "../LightConfig";

type Props = {
    drawHelpers?: boolean;
    config: DirectionalLightConfig;
};

export const DirectionalLight: React.FC<Props> = ({ drawHelpers, config }) => {
    const targetRef = React.useRef<THREE.Object3D>(null);

    return (
        <>
            <object3D ref={targetRef} position={config.target} />
            <directionalLight
                color={config.color}
                intensity={config.intensity}
                position={config.position}
                target={targetRef.current ?? undefined}
                castShadow={config.castShadow}
            />
            <mesh visible={drawHelpers} position={config.position}>
                <sphereGeometry args={[0.1, 16, 16]} />
                <meshStandardMaterial color="yellow" />
            </mesh>
            <mesh visible={drawHelpers} position={config.target}>
                <sphereGeometry args={[0.1, 16, 16]} />
                <meshStandardMaterial color="red" />
            </mesh>
        </>
    );
};
